export default {
  overdraft_opt_in_label: 'Eu autorizo que o débito automático seja inclusive sobre o meu limite de crédito em conta (<i>cheque especial</i>), se houver',
};
